import {
  CookieDataType,
  CookieType,
  IKameleoonData,
  KameleoonData,
} from './types';
import { TrackingStatus } from 'src/types';
import { KameleoonLogger } from 'src/logging';

/**
 * @class
 * Cookie - a class for creating an instance for defining user's cookie
 * */
export class Cookie implements IKameleoonData {
  public status: TrackingStatus;

  private cookie: CookieType[];

  /**
   * @param {CookieType[]} cookie - a list of cookies
   * */
  constructor(cookie: CookieType[]) {
    this.cookie = cookie;
    this.status = TrackingStatus.Sent;
  }

  /**
   * @method fromString - a static method for creating an instance of `Cookie` from a string
   * @param {string} cookieString - a string containing a list of cookies
   * @returns {Cookie} an instance of `Cookie`
   * */
  static fromString(cookieString: string): Cookie {
    if (!cookieString) {
      return new Cookie([]);
    }

    const pairs = cookieString.split(';');

    const cookie = pairs
      .map((item) => {
        const [key, value] = item.trim().split('=');

        if (!key) {
          KameleoonLogger.warning`Cookie string has an empty key: ${cookieString}`;
          return null;
        }

        return { key, value };
      })
      .filter((item) => item !== null);

    return new Cookie(cookie as CookieType[]);
  }

  get url(): string {
    return '';
  }

  get data(): CookieDataType {
    return {
      cookie: this.cookie,
      type: KameleoonData.Cookie,
      status: this.status,
    };
  }
}
